var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt-asset-gallery-modal"},[_c('asset-gallery',{ref:"assetGallery",attrs:{"closeModal":_vm.closeModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }